import { useAppSelector } from 'app/hooks';
import { useParams } from 'react-router-dom';

export const useParentOrg = () => {
  const { orgid } = useParams<{ orgid?: string }>();
  const orgs = useAppSelector((state) => state.org.list);
  const org = orgs.find((o) => o.id === Number(orgid));
  return org;
};
